(function () {
  var bars = document.querySelectorAll('[data-sticky-atc]');
  if (!bars.length) return;

  bars.forEach(function (bar) {
    initVisibility(bar);
    initFooterAvoidance(bar);
    initQuantitySync(bar);
    initAddToCart(bar);
  });

  /* ----------------------------------------------------------------------
     Money formatting — mirror Liquid's `money_without_trailing_zeros`
     ---------------------------------------------------------------------- */
  function formatMoneyNoZeros(cents) {
    var amount = (Number(cents) || 0) / 100;
    var isWhole = cents % 100 === 0;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return (isWhole ? amount.toFixed(0) : amount.toFixed(2)) + ' ' + currency;
    }
  }

  /* ----------------------------------------------------------------------
     Visibility: show the bar only once the main ATC button is scrolled past.
     Falls back to a fixed scroll offset if IntersectionObserver or the
     main ATC element is unavailable.
     ---------------------------------------------------------------------- */
  function initVisibility(bar) {
    var mainAtc = document.querySelector('[data-buy-buttons]');

    if (mainAtc && typeof IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var isScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (isScrolledPast) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });

      observer.observe(mainAtc);
      return;
    }

    var offset = Number(bar.getAttribute('data-scroll-trigger-offset')) || 400;
    var ticking = false;

    function update() {
      if (window.scrollY > offset) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* ----------------------------------------------------------------------
     Hide when the footer enters the viewport
     ---------------------------------------------------------------------- */
  function initFooterAvoidance(bar) {
    if (typeof IntersectionObserver === 'undefined') return;

    var footer =
      document.querySelector('.oddit-footer-main') ||
      document.querySelector('.section-footer') ||
      document.querySelector('footer');
    if (!footer) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.add('is-near-footer');
        } else {
          bar.classList.remove('is-near-footer');
        }
      });
    }, { threshold: 0 });

    observer.observe(footer);
  }

  /* ----------------------------------------------------------------------
     Mirror quantity changes from the main product section
     ---------------------------------------------------------------------- */
  function initQuantitySync(bar) {
    document.addEventListener('oddit:quantity-change', function (e) {
      var detail = e.detail || {};

      // Only sync if the event's product matches this bar (when both have a product id).
      var barProductId = bar.getAttribute('data-product-id');
      if (barProductId && detail.productId && String(detail.productId) !== String(barProductId)) {
        return;
      }

      var priceEl = bar.querySelector('[data-sticky-price]');
      if (priceEl && typeof detail.totalCents === 'number') {
        // Show the subscribe-adjusted price if the customer is in subscribe mode,
        // otherwise show the plain tier total.
        var isSubscribe = detail.subscriptionMode === 'subscribe' && typeof detail.subscribeTotalCents === 'number';
        priceEl.textContent = isSubscribe
          ? (detail.formattedSubscribeTotal || formatMoneyNoZeros(detail.subscribeTotalCents))
          : (detail.formattedTotal || formatMoneyNoZeros(detail.totalCents));
      }

      var atc = bar.querySelector('[data-add-to-cart]');
      if (atc) {
        if (detail.count) atc.setAttribute('data-quantity', String(detail.count));
        if (detail.sellingPlanId) {
          atc.setAttribute('data-selling-plan-id', String(detail.sellingPlanId));
        } else {
          atc.removeAttribute('data-selling-plan-id');
        }
      }
    });
  }

  /* ----------------------------------------------------------------------
     Add to cart — same approach as the main product ATC
     ---------------------------------------------------------------------- */
  function initAddToCart(bar) {
    var atc = bar.querySelector('[data-add-to-cart][data-variant-id]');
    if (!atc) return;

    atc.addEventListener('click', function (e) {
      e.preventDefault();
      if (atc.disabled) return;

      var variantId = atc.getAttribute('data-variant-id');
      if (!variantId) return;
      var quantity = Number(atc.getAttribute('data-quantity')) || 1;
      var sellingPlanId = atc.getAttribute('data-selling-plan-id') || null;

      atc.disabled = true;
      atc.classList.add('is-loading');

      var addPromise;
      if (window.OdditCartDrawer && typeof window.OdditCartDrawer.addToCart === 'function') {
        addPromise = window.OdditCartDrawer.addToCart(Number(variantId), quantity, null, sellingPlanId).then(function () {
          if (typeof window.OdditCartDrawer.open === 'function') window.OdditCartDrawer.open();
        });
      } else {
        var body = { id: Number(variantId), quantity: quantity };
        if (sellingPlanId) body.selling_plan = Number(sellingPlanId);
        addPromise = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        }).then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('oddit:cart:updated'));
        });
      }

      addPromise
        .catch(function (err) {
          console.error('Sticky ATC add to cart failed:', err);
        })
        .then(function () {
          atc.disabled = false;
          atc.classList.remove('is-loading');
        });
    });
  }
})();
